export default "__VITE_ASSET__18bd891e__"